// ** Initial State
const initialState = {
    data: [],
    total: 1,
  }
  
  const PlanPackageReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'GET_PLAN__PACKAGE_LIST':
        return {
          ...state,
          data: action.data,
          total: action.totalPages,
        }
      default:
        return state
    }
  }
  
  export default PlanPackageReducer;
  